import {FixedVTag} from "../../entities/FixedVTag";
import {EditBaseCtrl} from "./EditBaseCtrl";
import { StateParams, StateService } from "@uirouter/angularjs";
import {EditFixedVTagModel} from "../../models/edit/EditFixedVTagModel";
import {NotificationService} from "../../services/NotificationService";

export class EditFixedVTagCtrl extends EditBaseCtrl<FixedVTag>{
  public static $inject = ['$scope','$state','$stateParams','$uibModal','EditFixedVTagModel','NotificationService'];
  constructor($scope:any,
              stateService:StateService,
              stateParamsService:StateParams,
              public modal:angular.ui.bootstrap.IModalService,
              public model:EditFixedVTagModel,
              public notifyService:NotificationService) {
    super($scope,stateService,stateParamsService,notifyService,model);
    this.loadData().then((ok)=>{
    });
  }
  pagingRoute():string{
    return "admin.fixedvtags";
  }
}
